<template>
  <div class="navbar">
    <div class="nav-side left">
      <div class="nav-back" v-if="!isHome" @click="goHome">
        <span class="arrow">‹</span>
        <span>首页</span>
      </div>
    </div>
    <div class="nav-title">{{ pageTitle }}</div>
    <div class="nav-side right"></div>
  </div>
</template>

<script>
export default {
  name: 'nav-bar',
  computed: {
    isHome () {
      const p = this.$route.path
      return p === '/' || p === '/home'
    },
    pageTitle () {
      return (this.$route.meta && this.$route.meta.title) || '游戏中心'
    }
  },
  methods: {
    goHome () {
      if (!this.isHome) {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar{
  position: sticky;
  top: 0;
  z-index: 100;
  height: 52px;
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, #ffffff 0%, #f7faff 100%);
  border-bottom: 1px solid #eceff3;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  padding: 0 14px;
  box-sizing: border-box;
}
.nav-side{
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  &.right{
    justify-content: flex-end;
  }
}
.nav-back{
  display: inline-flex;
  align-items: center;
  gap: 2px;
  height: 32px;
  padding: 0 12px 0 10px;
  border-radius: 16px;
  background: #e3f2fd;
  color: #1e88e5;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: background-color 0.15s, transform 0.1s;
  .arrow{
    font-size: 20px;
    line-height: 1;
    margin-top: -1px;
  }
  &:active{
    background: #bbdefb;
    transform: scale(0.96);
  }
}
.nav-title{
  font-size: 17px;
  font-weight: bold;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.5px;
}
</style>
